// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'

const BettingAts = ({ val, percision }) => {

    var parsedVal = Math.round(100*parseFloat(val),percision)

    const c6n = '#ffcce0'
    const c4n = '#ffe3e3'
    const c2n = '#fff2ed'
    const c0 = '#ffffff'
    const c2p = '#edfff0'
    const c4p = '#e3ffef'
    const c6p = '#ccffef'

    var textColor = '#000000'

    // background //
    var calcedBackground = '#ffffff'
    if (isNaN(parsedVal)) {
        calcedBackground = '#ededed'
        textColor = '#b8b8b8'
    } else if (parsedVal <= 40) {
        calcedBackground = c6n
    } else if (parsedVal <= 44) {
        calcedBackground = tinycolor.mix(c6n, c4n, 100 * (parsedVal - 40) / 4 )
    } else if (parsedVal <= 48) {
        calcedBackground = tinycolor.mix(c4n, c2n, 100 * (parsedVal - 44) / 4)
    }  else if (parsedVal <= 52) {
        calcedBackground = tinycolor.mix(c2n, c0, 100 * (parsedVal - 48) / 4)
    } else if (parsedVal <= 56) {
        calcedBackground = tinycolor.mix(c0, c2p, 100 * (parsedVal - 52) / 4)
    } else if (parsedVal <= 60) {
        calcedBackground = tinycolor.mix(c2p, c4p, 100 * (parsedVal - 56) / 4)
    } else {
        calcedBackground = tinycolor.mix(c4p, c6p, 100 * (parsedVal - 60) / 4)
    }

    return (
        <div style={{
            background : calcedBackground,
            color: textColor,
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {isNaN(parsedVal) ? '--' : `${parsedVal}%`}
        </div>
    )
    
}

export default BettingAts